import { Group, Select, Stack } from '@forwardflow/ui-v2'
import { CheckCircle02Icon } from '@forwardflow/icons'
import { TFubUser } from '@forwardflow/types/onboarding'
import { PhoneNumberChange } from './PhoneNumberChange'

interface OwnerAccountSelectionProps {
   fubUser: Partial<TFubUser> | null
   editOwnerUser: boolean
   foundAccount: TFubUser | undefined
   fubOwnerUserData: Array<{ value: string; label: string }>
   isOnboardingCompleted: boolean
   onSelectOwner: (userId: string | null) => void
   setEditOwnerUser: (value: boolean) => void
   setFubUser: (value: Partial<TFubUser>) => void
}

export const OwnerAccountSelection = ({
   fubUser,
   editOwnerUser,
   foundAccount,
   fubOwnerUserData,
   isOnboardingCompleted,
   onSelectOwner,
   setEditOwnerUser,
   setFubUser,
}: OwnerAccountSelectionProps) => {
   const successLabel = (
      <Group>
         <CheckCircle02Icon width={16} color="#00D492" />
         We found your account from Follow Up Boss!
      </Group>
   )

   const defaultLabel = 'Select your Account from Follow Up Boss'

   return (
      <Stack>
         {editOwnerUser || !fubUser?.id ? (
            <Select
               searchable
               value={String(fubUser?.id)}
               data={fubOwnerUserData || []}
               placeholder="Search for your Account"
               label={foundAccount ? successLabel : defaultLabel}
               disabled={isOnboardingCompleted}
               onChange={onSelectOwner}
            />
         ) : (
            <>
               {foundAccount && successLabel}
               <PhoneNumberChange
                  fubUser={fubUser || {}}
                  setEditOwnerUser={setEditOwnerUser}
                  setFubUser={setFubUser}
               />
            </>
         )}
      </Stack>
   )
}

